import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../../utils/cx';
import styles from './Card.module.css';

type CardTone = 'elevated' | 'glass' | 'inset' | 'outlined';
type CardPadding = 'sm' | 'md' | 'lg';
type CardElement = 'article' | 'div' | 'section';

export interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: CardElement;
  children: ReactNode;
  interactive?: boolean;
  padding?: CardPadding;
  tone?: CardTone;
}

export function Card({
  as = 'div',
  children,
  className,
  interactive = false,
  padding = 'md',
  tone = 'elevated',
  ...props
}: CardProps) {
  const Component = as;

  return (
    <Component
      {...props}
      className={cx(
        styles.card,
        styles[tone],
        styles[`padding${padding[0].toUpperCase()}${padding.slice(1)}`],
        interactive && styles.interactive,
        className,
      )}
    >
      {children}
    </Component>
  );
}
